import { proxy } from 'valtio';

import type { PageLoadGlobals } from 'models';

export const pageLoadGlobalsState = proxy<{ globals: PageLoadGlobals | null }>({
    globals: null,
});
